import { Button } from "@/components/ui/button";

interface PwaInstallBannerProps {
  onDismiss: () => void;
  onInstall: () => Promise<boolean> | void;
  installLabel: string;
}

export function PwaInstallBanner({ onDismiss, onInstall, installLabel }: PwaInstallBannerProps) {
  return (
    <div className="fixed left-3 right-3 bottom-[calc(env(safe-area-inset-bottom,0px)+76px)] z-40 md:left-auto md:right-4 md:w-[380px]">
      <div className="rounded-2xl border border-divider bg-card/95 backdrop-blur-md shadow-2xl">
        <div className="flex items-start gap-3 px-4 py-4">
          <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-2xl bg-golden/15 text-golden">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" className="h-5 w-5">
              <path strokeLinecap="round" strokeLinejoin="round" d="M12 4.5v9m0 0l-3.5-3.5M12 13.5l3.5-3.5M5 16.5v1a2 2 0 002 2h10a2 2 0 002-2v-1" />
            </svg>
          </div>

          <div className="min-w-0 flex-1">
            <p className="text-xxs font-semibold uppercase tracking-[0.18em] text-golden/80">Install LYTICK</p>
            <p className="mt-1 text-sm font-semibold text-foreground">Keep the workspace on your home screen.</p>
            <p className="mt-1 text-xs leading-5 text-muted-foreground">
              It opens faster, runs full-screen, and is easier to return to during replay sessions.
            </p>
          </div>
        </div>

        <div className="flex items-center justify-end gap-2 px-4 pb-4">
          <Button variant="ghost" className="h-10 rounded-full px-4 text-xs" onClick={onDismiss}>
            Later
          </Button>
          <Button className="h-10 rounded-full px-4 text-xs font-semibold" onClick={() => void onInstall()}>
            {installLabel}
          </Button>
        </div>
      </div>
    </div>
  );
}
